<div id="footer">
  <div class="footerLink-dataSecurity-wrapper">
    <div [ngClass]="((brandingData$ | async)?.certificateLink === '') ? 'disable-data-security' : ''">
      <img src="/assets/img/general/patientus_secure.svg" alt="">
      {{ (brandingData$ | async)?.certificateLink === '' ?
      ('FOOTER.NOT-CERTIFIED' | translate) : ('FOOTER.CERTIFIED' | translate) }}
    </div>
  </div>
  <div class="footerLink-wrapper">
    <app-footer-legal-links [brandingData]="brandingData$ | async" />
  </div>
  <div class="footer-furtherLink-wrapper">
    @if ((brandingData$ | async).lang && (brandingData$ | async).lang.length > 1) {
      <app-translation [cssClass]="'footer'"></app-translation>
    }
    <a (click)="showFeedbackSurvey()">
      <i class="fal fa-paper-plane"></i>
      {{ 'FOOTER.FEEDBACK' | translate }}
    </a>
    @if ((brandingData$ | async)?.faqLink !== false) {
      <a target="_blank"
        href="{{ 'GENERAL.FAQ-LINK' | translate }}">
        <i class="fal fa-question-circle"></i>
        {{ 'FOOTER.FAQ' | translate }}
      </a>
    }
  </div>
</div>
